import { cn } from "@theprelude/core";

export const TerminalIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 14 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.00016 0H13.0002C13.177 0 13.3465 0.0702379 13.4716 0.195262C13.5966 0.320286 13.6668 0.489856 13.6668 0.666667V11.3333C13.6668 11.5101 13.5966 11.6797 13.4716 11.8047C13.3465 11.9298 13.177 12 13.0002 12H1.00016C0.823352 12 0.653782 11.9298 0.528758 11.8047C0.403734 11.6797 0.333496 11.5101 0.333496 11.3333V0.666667C0.333496 0.489856 0.403734 0.320286 0.528758 0.195262C0.653782 0.0702379 0.823352 0 1.00016 0V0ZM1.66683 1.33333V10.6667H12.3335V1.33333H1.66683ZM7.00016 8H11.0002V9.33333H7.00016V8ZM4.77816 6L2.89216 4.11467L3.8355 3.17133L6.6635 6L3.8355 8.82867L2.89216 7.88533L4.77816 6Z" />
  </svg>
);
